<div class="page-content page-content-full card align-items-center justify-content-center d-flex">
	<div class="text-center">
		<!-- TODO: css vars have to be changed to --dyn-primary when white labeling is merged -->
		<div class="fallback-symbol mb-3">
			<svg id="Gruppe_471" data-name="Gruppe 471" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="119.868" height="98.485" viewBox="0 0 119.868 98.485">
			  <defs>
			    <clipPath id="clip-path">
			      <rect id="Rechteck_368" data-name="Rechteck 368" width="119.868" height="98.485" fill="none"/>
			    </clipPath>
			  </defs>
			  <g id="Gruppe_470" data-name="Gruppe 470" clip-path="url(#clip-path)">
			    <path id="Pfad_124" data-name="Pfad 124" d="M113.369,211.286c0,1.928-23.224,3.491-51.873,3.491s-51.873-1.563-51.873-3.491S32.847,207.8,61.5,207.8s51.873,1.563,51.873,3.491" transform="translate(-5.385 -116.291)" fill="#e6e6e6"/>
			    <path id="Pfad_126" data-name="Pfad 126" d="M1.409,44.15c4.346-7.662,29.945-16.043,39.232-24.51A80.447,80.447,0,0,0,55.355,1.381l39.5,23.109L97.3,34.223s-.922,4.056-10.256,12.566-35.071,16.937-39.3,24.625L1.345,44.265Z" transform="translate(10.68 7.571)" fill="none" stroke="var(--dyn-primary)" stroke-miterlimit="10" stroke-width="3"/>
			    <path id="Pfad_127" data-name="Pfad 127" d="M258.55,66.364l-4.426,7.565,7.42,4.341" transform="translate(-153.561 -34.303)" fill="none" stroke="var(--dyn-primary)" stroke-miterlimit="10" stroke-width="2"/>
			  </g>
			</svg>
		</div>	
		<p>
			<span [innerHTML]="fallBackMessage"></span><br>
		</p>
	</div>
</div>